import axios from 'axios'
import store from "../store";
import { getApiUrl } from "@/helpers";

/**
 * Gets the print token from URL query parameters if present.
 * Used for auto-print pages that need to authenticate API requests.
 */
function getPrintTokenFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('printToken');
}

const service = axios.create({
    // getApiUrl handles Electron detection internally
    baseURL: getApiUrl(''),
    withCredentials: true,
    headers: {
        'Access-Control-Allow-Origin': '*'
    }
    // timeout: 100000 // request timeout
})

// Request interceptor to add print token header if present
service.interceptors.request.use(config => {
    const printToken = getPrintTokenFromUrl();
    if (printToken) {
        config.headers['X-Print-Token'] = printToken;
    }
    return config;
});

service.interceptors.response.use(response => {
    return response
},
    error => {
        // Don't redirect to login for print token auth failures
        const printToken = getPrintTokenFromUrl();
        if (error.response?.status === 401 && !printToken) {
            store.dispatch("logout").then(() => {
                if (!location.href.includes("/login")) location.href = "/login";
            });
        }
        return Promise.reject(error)
    }
)

export default service
